import { render, staticRenderFns } from "./ScheduledPostItem.vue?vue&type=template&id=0fea6024&scoped=true&"
import script from "./ScheduledPostItem.vue?vue&type=script&lang=js&"
export * from "./ScheduledPostItem.vue?vue&type=script&lang=js&"
import style0 from "./ScheduledPostItem.vue?vue&type=style&index=0&id=0fea6024&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fea6024",
  null
  
)

export default component.exports